import { render, staticRenderFns } from "./newFooter.vue?vue&type=template&id=f07d090e&scoped=true&"
import script from "./newFooter.vue?vue&type=script&lang=js&"
export * from "./newFooter.vue?vue&type=script&lang=js&"
import style0 from "./newFooter.vue?vue&type=style&index=0&id=f07d090e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f07d090e",
  null
  
)

export default component.exports